module.exports = __webpack_public_path__ + "img/email-preview-header.ef76418.png";